import React, { useState } from 'react';
import { useSpring } from '@react-spring/web';
import { isOnServer, useIsQuoteButtonsEnabled } from '../../../utils';
import DeviceSection from './DeviceSection';
import FloatingQuoteButton from '../../Device/FloatingQuoteButton';
import styles from './index.module.scss';

export default function DeviceSections({ pageData, scrollSpring, debug = false }) {
  const { sections = [] } = pageData;
  const firstProduct = sections[0]?.product || pageData.defaultProduct;

  let [pageChangeState, setPageChangeState] = useState(() => ({
    pageNum: 0,
    pageNumDiff: 0,
    product: firstProduct,
  }));

  // we use useSpring 👇 to track state changes subscribing changes from the
  // central animSpring, updates state when currentPageNum in animSpring changes
  useSpring(
    () => ({
      currentPageNum: scrollSpring.currentPageNum,
      prevPageNum: scrollSpring.prevPageNum,
      onChange: () => {
        let currentPageNum = Math.round(scrollSpring.currentPageNum.get());
        let prevPageNum = Math.round(scrollSpring.prevPageNum.get());
        let pageNum = Math.floor(pageChangeState.pageNum);
        if (currentPageNum !== pageNum) {
          let newPageNum = Math.max(0, currentPageNum); // make sure mobile scrolling above top makes negative values
          let pageNumDiff = currentPageNum - prevPageNum;
          let product = newPageNum < sections.length ? sections[newPageNum]?.product || pageData.defaultProduct : null;
          setPageChangeState({
            pageNum: newPageNum,
            pageNumDiff,
            product,
          });
        }
      },
    }),
    [scrollSpring, pageData, pageChangeState]
  );

  let pathname = isOnServer ? '' : window.location.pathname;
  return (
    <div className={styles.deviceSections}>
      {sections.map((section, index) => {
        return (
          <DeviceSection
            key={index}
            section={section}
            index={index}
            debug={debug}
            pageChangeState={pageChangeState}
            // imageUrl={imageUrls[section.mainFrame]}
          />
        );
      })}
      <DeviceSection
        key="spacerSection"
        index={sections.length}
        className={styles.spacerSection}
        debug={debug}
        pageChangeState={pageChangeState}
      />
      {useIsQuoteButtonsEnabled && (
        <FloatingQuoteButton
          product={pageChangeState.product}
          heading="Add to quote"
          tracking={{
            category: 'Device',
            action: `Floating 'Add to quote' button clicked`,
            label: pathname,
          }}
        />
      )}
    </div>
  );
}
